<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    offset-x
    style="z-index: 999">
    <template v-slot:activator="{ on, attrs }">
    <v-btn
      icon
      v-bind="attrs"
      v-on="on"
      data-testid="sms-title-context-menu"
      class="context-menu-btn-sms-title"
    >
      <v-icon>mdi-dots-vertical</v-icon>
    </v-btn>
    </template>
    <v-card style="width: 370px;" flat>
      <v-card-title>
        <v-icon class="mr-3">mdi-cog</v-icon>
        <span>{{ $t('chat.smsSettings') }}</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="menu = false">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
        <v-expansion-panels focusable v-model="expansionPanel" accordion>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <span>{{ $t('chat.smsContextMenu.title') }}</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card-text class="mx-0 px-0">
              <span>{{ $t('chat.smsContextMenu.filterSortBy') }}</span>
              <Sort v-show="smsDids.length > 0"/>
              <br/>
              <span v-show="smsDids.length > 1">{{ $t('chat.smsContextMenu.filterMySmsDid') }}</span>
              <PhoneNumbersFilter v-show="smsDids.length > 0"/>
              <br />
              <ClosedFilter/>
              <ReadFilter/>
            </v-card-text>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <span>{{ $t('chat.smsToEmails.title') }}</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <sms-to-emails />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import PhoneNumbersFilter from '@/components/chat/drawer/direct_chats/sms_context_menu/phone_numbers_filter'
import Sort from '@/components/chat/drawer/direct_chats/sms_context_menu/sort'
import ClosedFilter from '@/components/chat/drawer/direct_chats/sms_context_menu/closed_filter.vue'
import ReadFilter from '@/components/chat/drawer/direct_chats/sms_context_menu/read_filter.vue'
import SmsToEmails from '@/components/chat/drawer/direct_chats/sms_context_menu/sms_to_emails.vue'

export default {
  name: 'chat-sms-title-contextmenu',
  data () {
    return {
      menu: false,
      expansionPanel: 0
    }
  },
  components: {
    PhoneNumbersFilter,
    Sort,
    ClosedFilter,
    ReadFilter,
    SmsToEmails
  },
  computed: {
    ...mapGetters({
      smsDids: 'chat/smsDids',
      paginationDm: 'chat/paginationDm'
    })
  }
}
</script>

<style>

</style>
